<div class="website-content" style="max-width:72rem;padding:0 var(--wa-spacing-x-large) var(--wa-spacing-x-large) var(--wa-spacing-x-large);">
	<div class="wa-stack wa-gap-xl">
		<wa-button [routerLink]="['/plugins']" appearance="plain" variant="neutral">Back to Plugins</wa-button>
		<wa-card appearance="outlined">
			<div class="wa-stack wa-gap-m">
				<div class="wa-stack wa-gap-s">
					<h1 waHeading="xl" waText>Font Awesome</h1>
					<p waBody="m" waText>Font Awesome Free 7.2.0 &mdash; scalable vector icons &#40;Solid and Brands sets&#41; rendered via SVG with Angular FontAwesome integration and type-safe Java enum API. 2,000+ free icons with transformations, layering, masking, and animation effects.</p>
					<div class="wa-cluster wa-gap-xs">
						<wa-tag pill variant="neutral">Java 25+</wa-tag>
						<wa-tag pill variant="neutral">Font Awesome 7.2.0</wa-tag>
						<wa-tag pill variant="neutral">Angular 21</wa-tag>
						<wa-tag pill variant="neutral">TypeScript 5</wa-tag>
						<wa-tag pill variant="neutral">JPMS Modular</wa-tag>
					</div>
				</div>
				<wa-divider></wa-divider>
				<div class="wa-stack wa-gap-xs">
					<div waCaption="s" waFontWeight="semibold" waText>COORDINATES &amp; MODULE</div>
					<p waBody="s" waText>Maven: com.jwebmp.plugins:fontawesome</p>
					<p waBody="s" waText>JPMS Module: com.jwebmp.plugins.fontawesome5</p>
					<p waBody="s" waText>Built on: Font Awesome 7.2.0</p>
				</div>
				<wa-details summary="Installation">
					<div class="wa-stack wa-gap-xs">
						@if (!useGradle) {
							<div class="code-block-wrapper">
								<div class="code-block-label" waCaption="s" waFontWeight="semibold" waText>Maven</div>
								<markdown [data]="mdContent_570" class="aside-snippet-code wa-body-s" clipboard lineNumbers></markdown>
							</div>
						}
						@if (useGradle) {
							<div class="code-block-wrapper">
								<div class="code-block-label" waCaption="s" waFontWeight="semibold" waText>Gradle &#40;Kotlin DSL&#41;</div>
								<markdown [data]="mdContent_571" class="aside-snippet-code wa-body-s" clipboard lineNumbers></markdown>
							</div>
						}
					</div>
				</wa-details>
				<wa-details summary="NPM Dependencies (auto-included)">
					<markdown [data]="mdContent_572" class="aside-snippet-code wa-body-s" clipboard lineNumbers></markdown>
				</wa-details>
				<wa-divider></wa-divider>
				<div class="wa-stack wa-gap-m">
					<h2 waHeading="l" waText>Components &#40;10&#41;</h2>
					<p waBody="m" waText>Click any component to see its full API &mdash; properties, constructors, methods, events, slots, and examples.</p>
					<div class="wa-grid wa-gap-s" style="--min-column-size:18rem;">
						<wa-card appearance="outlined">
							<div class="wa-stack wa-gap-xs">
								<h4 waHeading="s" waText>FontAwesome</h4>
								<p waBody="s" waColorText="quiet" waText>Icon component &mdash; renders an fa-icon Angular element with style, icon enum, size, animation, transforms, masking, and duotone color support</p>
								<div class="wa-cluster wa-gap-xs">
									<wa-tag pill variant="brand">2 props</wa-tag>
									<wa-tag pill variant="neutral">21 methods</wa-tag>
									<wa-tag pill variant="success">6 examples</wa-tag>
								</div>
								<wa-button [routerLink]="['/plugins/fontawesome/font-awesome']" appearance="plain" variant="brand">View Details &rarr;</wa-button>
							</div>
						</wa-card>
						<wa-card appearance="outlined">
							<div class="wa-stack wa-gap-xs">
								<h4 waHeading="s" waText>FontAwesomeLayers</h4>
								<p waBody="s" waColorText="quiet" waText>Layered icon container &mdash; combines multiple icons, counters, and text overlays using fa-layers Angular element</p>
								<div class="wa-cluster wa-gap-xs">
									<wa-tag pill variant="neutral">14 methods</wa-tag>
									<wa-tag pill variant="success">3 examples</wa-tag>
								</div>
								<wa-button [routerLink]="['/plugins/fontawesome/font-awesome-layers']" appearance="plain" variant="brand">View Details &rarr;</wa-button>
							</div>
						</wa-card>
						<wa-card appearance="outlined">
							<div class="wa-stack wa-gap-xs">
								<h4 waHeading="s" waText>FontAwesomeLayerCounter</h4>
								<p waBody="s" waColorText="quiet" waText>Counter badge &mdash; renders a fa-layers-counter element overlaid on icon layers, typically used for notification counts</p>
								<div class="wa-cluster wa-gap-xs">
									<wa-tag pill variant="neutral">2 methods</wa-tag>
									<wa-tag pill variant="success">1 examples</wa-tag>
								</div>
								<wa-button [routerLink]="['/plugins/fontawesome/font-awesome-layer-counter']" appearance="plain" variant="brand">View Details &rarr;</wa-button>
							</div>
						</wa-card>
						<wa-card appearance="outlined">
							<div class="wa-stack wa-gap-xs">
								<h4 waHeading="s" waText>FontAwesomeLayerText</h4>
								<p waBody="s" waColorText="quiet" waText>Text overlay &mdash; renders a fa-layers-text element overlaid on icon layers, used for labels and badges within stacked icons</p>
								<div class="wa-cluster wa-gap-xs">
									<wa-tag pill variant="neutral">2 methods</wa-tag>
									<wa-tag pill variant="success">1 examples</wa-tag>
								</div>
								<wa-button [routerLink]="['/plugins/fontawesome/font-awesome-layer-text']" appearance="plain" variant="brand">View Details &rarr;</wa-button>
							</div>
						</wa-card>
						<wa-card appearance="outlined">
							<div class="wa-stack wa-gap-xs">
								<h4 waHeading="s" waText>FontAwesomeList</h4>
								<p waBody="s" waColorText="quiet" waText>Icon list &mdash; replaces default list bullets with Font Awesome icons using fa-ul/fa-li CSS classes</p>
								<div class="wa-cluster wa-gap-xs">
									<wa-tag pill variant="neutral">2 methods</wa-tag>
									<wa-tag pill variant="success">1 examples</wa-tag>
								</div>
								<wa-button [routerLink]="['/plugins/fontawesome/font-awesome-list']" appearance="plain" variant="brand">View Details &rarr;</wa-button>
							</div>
						</wa-card>
						<wa-card appearance="outlined">
							<div class="wa-stack wa-gap-xs">
								<h4 waHeading="s" waText>FontAwesomeIcons</h4>
								<p waBody="s" waColorText="quiet" waText>Enum of 1,932 free solid/classic icons &mdash; pass to FontAwesome constructor or setIcon&#40;&#41; as the icon value</p>
								<div class="wa-cluster wa-gap-xs">
									<wa-tag pill variant="brand">14 props</wa-tag>
									<wa-tag pill variant="success">1 examples</wa-tag>
								</div>
								<wa-button [routerLink]="['/plugins/fontawesome/font-awesome-icons']" appearance="plain" variant="brand">View Details &rarr;</wa-button>
							</div>
						</wa-card>
						<wa-card appearance="outlined">
							<div class="wa-stack wa-gap-xs">
								<h4 waHeading="s" waText>FontAwesomeBrandIcons</h4>
								<p waBody="s" waColorText="quiet" waText>Enum of 462 brand icons &mdash; automatically uses Brand style when no style is specified</p>
								<div class="wa-cluster wa-gap-xs">
									<wa-tag pill variant="brand">11 props</wa-tag>
									<wa-tag pill variant="success">1 examples</wa-tag>
								</div>
								<wa-button [routerLink]="['/plugins/fontawesome/font-awesome-brand-icons']" appearance="plain" variant="brand">View Details &rarr;</wa-button>
							</div>
						</wa-card>
						<wa-card appearance="outlined">
							<div class="wa-stack wa-gap-xs">
								<h4 waHeading="s" waText>FontAwesomeStyles</h4>
								<p waBody="s" waColorText="quiet" waText>Enum of icon styles &mdash; determines which icon font family is used for rendering</p>
								<div class="wa-cluster wa-gap-xs">
									<wa-tag pill variant="brand">4 props</wa-tag>
								</div>
								<wa-button [routerLink]="['/plugins/fontawesome/font-awesome-styles']" appearance="plain" variant="brand">View Details &rarr;</wa-button>
							</div>
						</wa-card>
						<wa-card appearance="outlined">
							<div class="wa-stack wa-gap-xs">
								<h4 waHeading="s" waText>FontAwesomeSizes</h4>
								<p waBody="s" waColorText="quiet" waText>Enum of icon sizes &mdash; relative scaling from extra-small to 10x</p>
								<div class="wa-cluster wa-gap-xs">
									<wa-tag pill variant="brand">12 props</wa-tag>
								</div>
								<wa-button [routerLink]="['/plugins/fontawesome/font-awesome-sizes']" appearance="plain" variant="brand">View Details &rarr;</wa-button>
							</div>
						</wa-card>
						<wa-card appearance="outlined">
							<div class="wa-stack wa-gap-xs">
								<h4 waHeading="s" waText>FontAwesomeTransforms</h4>
								<p waBody="s" waColorText="quiet" waText>Enum of power transforms &mdash; scale, position, rotate, and flip icons in 1/16em increments without affecting container</p>
								<div class="wa-cluster wa-gap-xs">
									<wa-tag pill variant="brand">55 props</wa-tag>
									<wa-tag pill variant="success">1 examples</wa-tag>
								</div>
								<wa-button [routerLink]="['/plugins/fontawesome/font-awesome-transforms']" appearance="plain" variant="brand">View Details &rarr;</wa-button>
							</div>
						</wa-card>
					</div>
				</div>
				<wa-details summary="Features (11)">
					<div class="wa-stack wa-gap-xs">
						<p waBody="s" waColorText="quiet" waText>2,000+ free icons &mdash; Font Awesome Free Solid and Brands icon sets</p>
						<p waBody="s" waColorText="quiet" waText>Type-safe Java enum API &mdash; FontAwesomeIcons and FontAwesomeBrandIcons with compile-time safety</p>
						<p waBody="s" waColorText="quiet" waText>Multiple icon styles &mdash; Solid and Brand styles included</p>
						<p waBody="s" waColorText="quiet" waText>SVG or Web Font rendering &mdash; choose between SVG core or classic CSS web fonts</p>
						<p waBody="s" waColorText="quiet" waText>Icon transformations &mdash; rotate, flip, scale, position with fluent API</p>
						<p waBody="s" waColorText="quiet" waText>Layering and masking &mdash; combine multiple icons with layers and masks</p>
						<p waBody="s" waColorText="quiet" waText>Animation effects &mdash; built-in spin, pulse, and custom animations</p>
						<p waBody="s" waColorText="quiet" waText>Sizing options &mdash; preset sizes from xs to 10x, or custom sizing</p>
						<p waBody="s" waColorText="quiet" waText>Angular FontAwesome module integration</p>
						<p waBody="s" waColorText="quiet" waText>CRTP fluent API for icon configuration</p>
						<p waBody="s" waColorText="quiet" waText>Zero configuration &mdash; auto-registered via ServiceLoader SPI</p>
					</div>
				</wa-details>
				<wa-divider></wa-divider>
				<wa-details open summary="Examples (2)">
					<div class="wa-stack wa-gap-m">
						<div class="wa-stack wa-gap-xs">
							<h4 waHeading="s" waText>Basic Icons</h4>
							<p waBody="s" waColorText="quiet" waText>Create solid and brand icons with animation.</p>
							<markdown [data]="mdContent_573" class="aside-snippet-code wa-body-s" clipboard lineNumbers></markdown>
						</div>
						<div class="wa-stack wa-gap-xs">
							<h4 waHeading="s" waText>Layered Icons</h4>
							<p waBody="s" waColorText="quiet" waText>Combine multiple icons with layers and counters.</p>
							<markdown [data]="mdContent_574" class="aside-snippet-code wa-body-s" clipboard lineNumbers></markdown>
						</div>
					</div>
				</wa-details>
				<wa-details open summary="Quick Start">
					<markdown [data]="mdContent_575" class="aside-snippet-code wa-body-s" clipboard lineNumbers></markdown>
				</wa-details>
				<wa-divider></wa-divider>
				<wa-details open summary="SPI Extension Point Details (1)">
					<div class="wa-stack wa-gap-s">
						<div class="wa-stack wa-gap-xs">
							<div class="wa-cluster wa-gap-xs">
								<wa-tag pill variant="success">IPageConfigurator</wa-tag>
								<wa-tag pill variant="neutral">provides</wa-tag>
							</div>
							<p waBody="s" waColorText="quiet" waText>FontAwesomePageConfigurator auto-registers fontawesome-svg-core and Angular FontAwesome module</p>
						</div>
					</div>
				</wa-details>
				<wa-details open summary="SPI Extension Points">
					<div class="wa-stack wa-gap-xs">
						<div class="wa-cluster wa-gap-xs">
							<wa-tag pill variant="success">provides IPageConfigurator</wa-tag>
						</div>
					</div>
				</wa-details>
				<wa-divider></wa-divider>
				<wa-details open summary="Prerequisites">
					<div class="wa-cluster wa-gap-xs">
						<wa-tag pill variant="neutral">Java 25 LTS</wa-tag>
						<wa-tag pill variant="neutral">Maven 3.9+</wa-tag>
						<wa-tag pill variant="neutral">Node.js 18+</wa-tag>
						<wa-tag pill variant="neutral">Angular 21+</wa-tag>
					</div>
				</wa-details>
				<wa-divider></wa-divider>
				<div class="wa-cluster wa-gap-s">
					<wa-tag pill variant="neutral">Upstream: https://fontawesome.com/</wa-tag>
					<wa-tag pill variant="neutral">Docs: https://fontawesome.com/docs</wa-tag>
					<wa-tag pill variant="neutral">Source: https://github.com/JWebMP/FontAwesome</wa-tag>
				</div>
			</div>
		</wa-card>
	</div>
</div>